var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising"},[_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('iframe',{staticStyle:{"top":"10px"},attrs:{"src":_vm.url,"frameborder":"0","id":"iframe","width":"100%","height":"90%","scrolling":"no"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6074eaeb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/advertising.vue
// module id = null
// module chunks = 